import { createFeatureSelector, createSelector } from '@ngrx/store';
import { domainsAdapter, DomainsState } from './domains.adapter';
import { RequestStatus } from '../../enums/request-status.enum';

export const selectDomainsState = createFeatureSelector<DomainsState>('domains');

export const {
  selectAll: selectAllDomains,
  selectEntities: selectDomainsEntities,
  selectIds: selectDomainsIds,
  selectTotal: selectDomainsTotal,
} = domainsAdapter.getSelectors(selectDomainsState);

export const selectDomainsStatus = createSelector(
  selectDomainsState,
  (state) => state.status
);

export const selectDomainsError = createSelector(
  selectDomainsState,
  (state) => state.error
);

export const selectDomainsLoading = createSelector(
  selectDomainsStatus,
  (status) => status === RequestStatus.Loading
);

export const selectDomainsLoaded = createSelector(
  selectDomainsStatus,
  (status) => status === RequestStatus.Success
);

export const selectCurrentDomainId = createSelector(
  selectDomainsState,
  (state) => state.currentDomainId
);

export const selectCurrentDomain = createSelector(
  selectDomainsEntities,
  selectCurrentDomainId,
  (domainsEntities, currentDomainId) =>
    currentDomainId ? domainsEntities[currentDomainId] || null : null
);

